import { ComponentIds, HierarchyUtils } from '@inter-ikea-core/core';
import { TopPanelSystem } from '@inter-ikea-storageone/range';
import { useCore } from 'contexts/core';
import { useAppDispatch } from 'ducks/hooks';
import addTop from 'rangeConfig/shared/behaviors/addTop';
import deleteTop from 'rangeConfig/shared/behaviors/deleteTop';
import React, { useEffect } from 'react';
import { isMobile } from 'utils/platform';
import TopPanelWidgetBase from './TopPanelWidgetBase';
import store from 'ducks/configureStore';
import { showTopFrameWidgetInfoSheet } from 'rangeConfig/shared/features/TopFrameWidgetInfo/TopFrameWidgetInfoFeature';
import { useBehaviorTracker } from 'contexts/behaviors';

const TopPanelWidgetSelectedMenu = () => {
  const coreApi = useCore();
  const dispatch = useAppDispatch();
  const behaviorTracker = useBehaviorTracker();
  const selectedEntity = coreApi.entities.findSelectedEntity();
  const rootState = store.getState();
  const topPanelSystem = coreApi.getSystem<TopPanelSystem>('TopPanelSystem');
  const topProduct = rootState.products.inMarket.find(
    p => p.type === topPanelSystem?.topPanelProductType
  );

  const props = {
    coreProductId: topProduct?.coreProductId,
    menu: 'selected_menu'
  };

  const frame =
    selectedEntity &&
    HierarchyUtils.findWithComponentInUpwardsHierarchy(
      selectedEntity,
      ComponentIds.FRAME_COMPONENT_ID
    );

  const frameHasTopPanel =
    frame &&
    topPanelSystem &&
    coreApi.entities.getChildrenWithProductType(frame, topPanelSystem.topPanelProductType).length >
      0;

  const [isTopPanelAdded, setIsTopPanelAdded] = React.useState(frameHasTopPanel || false);

  useEffect(() => {
    setIsTopPanelAdded(frameHasTopPanel || false);
  }, [frameHasTopPanel]);

  const handleTopPanelToggle = () =>
    behaviorTracker.custom(() => {
      if (frameHasTopPanel || isTopPanelAdded) {
        deleteTop({ coreApi, dispatch, rootState, props });
        setIsTopPanelAdded(false);
      } else {
        addTop({ coreApi, dispatch, rootState, props });
        setIsTopPanelAdded(true);
      }
    });

  return (
    <TopPanelWidgetBase
      handleChange={handleTopPanelToggle}
      toggleLabel={'storageone.platsaTopWidgetLabel'}
      toggleEnabled={isTopPanelAdded}
      px={isMobile() ? '1rem' : '0'}
      onInfoTextClick={() => dispatch(showTopFrameWidgetInfoSheet())}
    />
  );
};

export default TopPanelWidgetSelectedMenu;
